import * as Yup from 'yup';

export const baseValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    middleName: Yup.string().nullable(),
    lastName: Yup.string().required('Last name is required'),
    addrNo: Yup.string().nullable(),
    addrUnit: Yup.string().nullable(),
    addrStreet: Yup.string().nullable(),
    addrCity: Yup.string().nullable(),
    addrProvince: Yup.string().nullable(),
    addrPostal: Yup.string().nullable(),
    phone: Yup.string()
        .matches(/^\d{10}$/, 'Invalid phone number format')
        .required('Phone number is required'),
    email: Yup.string()
        .email('Invalid email address')
        .required('Email address is required'),
    emergencyContactName1: Yup.string().nullable(),
    emergencyContactPhone1: Yup.string()
        .matches(/^\d{10}$/, 'Invalid phone number format')
        .nullable(),
    emergencyContactName2: Yup.string().nullable(),
    emergencyContactPhone2: Yup.string()
        .matches(/^\d{10}$/, 'Invalid phone number format')
        .nullable(),
    role: Yup.string().required('Role is required'),
});

export const newFormValidationSchema = baseValidationSchema.shape({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters long')
        .required('Password is required')
        .nullable(),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Password is required')
        .nullable(),
});

export const editFormValidationSchema = baseValidationSchema.shape({
    status: Yup.string().oneOf(["active", "inactive"]),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters long')
        .nullable(),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .nullable(),
});

